import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';

import { 
  getActiveAgencyUser,
  getAgencyUsers 
} from '../../shared/redux/selectors';

import {
  updateUser
} from '../../shared/redux/entities/actions';


function mapStateToProps(state){
  const activeUser = getActiveAgencyUser(state);

  //TODO: Connect Redux state to AgencyManageAccoutTeam
  return {
    users:getAgencyUsers(state, activeUser.agencyId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AgencyManageAccoutTeam
  return bindActionCreators({ updateUser },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutTeam/connect.js